import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import withTranslations from '../../../translations';

import {
  Button,
  FormControl,
  Input,
  InputLabel,
  Paper,
  Switch,
  Typography,
} from '../../base';

import { Icon } from '@material-ui/core';

import {
  getMyJobs,
  getOtherJobs,
  setSorting,
  setFilters,
  clearFilters,
} from '../../../actions/jobs';

import { filterFields } from './constants';

const styles = theme => ({
  inputs: {
    height: '100%',
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: '20px',
    [theme.breakpoints.up('lg')]: {
      marginTop: '0',
    },
  },
  topFiltersContainer: {
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(7),
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(5),
    },
  },
  filterInput:{
    width: '99%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    color: theme.palette.primary.main,

    '& .MuiInput-root': {
      width: '100%',
    },
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginTop: theme.spacing(2),
    height: 48,
  },
  filterField: {
    display: 'inline-flex',
    width: '100%',
    height: 48,

    [theme.breakpoints.up('lg')]: {
      width: '20%',
    },
  },
  filterSwitch: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',

    [theme.breakpoints.up('lg')]: {
      justifyContent: 'center',
    },
  },
  topFilterPaper: {
    width: '100%',
    marginTop: theme.spacing(1),

    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(0),
      marginRight: theme.spacing(1),
    },
  },
  searchIcon: {
    color: theme.palette.primary.main,
  }
})

class TopFilters extends Component {
  state = {
    ...this.props.filter,
  }

  componentDidUpdate(prevProps) {
    this.props.filter !== prevProps.filter && this.setState({...this.props.filter});
  }

  handleSwitchField = name => async e => {
    const isSwitchChecked = e.target.checked;

    await (name !== 'finalReportReleased')
      ? this.setState(prevState => ({
          ...prevState, [name]: isSwitchChecked
        }))
      : isSwitchChecked === true
        ? this.setState(prevState => ({
            status: {...prevState.status, [name]: 'FULFILLED'}
          }))
        : this.setState(prevState => ({
            status: {...prevState.status, [name]: ''}
          }));

    const filter = {...this.state};
    await this.props.actions.setFilters(filter);

    this.props.actions.getMyJobs({filter});
    this.props.actions.getOtherJobs({filter});
  }

  onFilterSubmit = () => {
    const filter = {...this.props.filter};

    this.props.actions.getMyJobs({filter});
    this.props.actions.getOtherJobs({filter});
    this.props.actions.setFilters(filter);
  }

  handleInput = name => e => {
    this.setState({[name]: e.target.value});
  }

  onClearFilters = async () => {
    await this.props.actions.clearFilters();

    this.setState({
      ...this.props.filter,
    })
  }

  handleSearch = field => {
    const filter = {...this.state};

    this.props.actions.setFilters(filter)
    this.props.actions.getMyJobs({filter});
    this.props.actions.getOtherJobs({filter});
  }

  handleInputFieldEnterKeyConfirmation = fieldName => e => {
     e.keyCode === 13 && !this.props.filter.isSubmitting && this.handleSearch(this.state[fieldName]);
  }

  renderFilterFields = filterFields => {
    const { classes: c } = this.props;
    let inputFields = filterFields
      .filter(({ type }) => type === 'input')
      .map(({ name, label }) => (
          <FormControl key={name} className={this.props.classes.filterInput}>
            <Fragment>
              <InputLabel>{label}</InputLabel>
              <Input value={this.state[name]}
                onInput={this.handleInput(name)}
                disabled={this.props.filter.isSubmitting}
                onKeyDown={this.handleInputFieldEnterKeyConfirmation(name)}/>
            </Fragment>
            <Icon
              onClick={() => !this.props.filter.isSubmitting && this.handleSearch(this.state[name])}
              disabled={this.props.filter.isSubmitting}
              fontSize="large"
              color={this.props.filter.isSubmitting ? 'disabled' : 'secondary'}
            >
              search
            </Icon>
          </FormControl>
      ));
    inputFields = <div key={'inputFields'} className={c.filterField} stype={{backgroundColor:'red'}}>
      <div className={c.inputs}>
        {inputFields}
      </div>
    </div>

    const nonInputFields = filterFields
      .filter(({ type }) => type !== 'input')
      .map(({ name, label, type }) => {
        switch (type) {
          case 'title':
            return <Typography variant='subtitle1' key={name} >{label}:</Typography>;
          case 'switch':
            return (
              <div className={c.filterField} key={name}>
                <div className={this.props.classes.filterSwitch}>
                  <Typography variant='subtitle1'>{label}:</Typography>
                  <Switch
                    value={name}
                    disableRipple={false}
                    disabled={this.props.filter.isSubmitting}
                    checked={name !== 'finalReportReleased'
                            ? this.props.filter[name]
                            : this.props.filter.status[name] === 'FULFILLED'
                              ? true
                              : false}
                    onChange={this.handleSwitchField(name)}
                  />
                </div>
              </div>
            );
          default:
            return null;
        }
      });

    return [...nonInputFields, inputFields];
  }

  renderApplyButton = t => (
    <Button className={this.props.classes.applyButton} onClick={this.onFilterSubmit}>
      {t.applyButton}
    </Button>
  )

  render() {
    const { t, gt, classes: c} = this.props;
    return (
      <Fragment>
        <Paper className={c.topFilterPaper}>
          <div className={c.topFiltersContainer}>
            {this.renderFilterFields(filterFields(t, gt.Status))}
          </div>
        </Paper>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  filter: state.jobs.filter,
})

const mapDispatchToProps = dispatch => ({
  actions: {
    getMyJobs: bindActionCreators(getMyJobs, dispatch),
    getOtherJobs: bindActionCreators(getOtherJobs, dispatch),
    setSorting: bindActionCreators(setSorting, dispatch),
    setFilters: bindActionCreators(setFilters, dispatch),
    clearFilters: bindActionCreators(clearFilters, dispatch),
  },
})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(TopFilters, 'Filters')));



// WEBPACK FOOTER //
// ./src/components/Jobs/TopFilters/TopFilters.js